import { render, staticRenderFns } from "./OrderMealDialog.vue?vue&type=template&id=59d13cc9&"
import script from "./OrderMealDialog.vue?vue&type=script&lang=js&"
export * from "./OrderMealDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports